import { render } from "./InfoButton.vue?vue&type=template&id=1f0dde31&scoped=true"
import script from "./InfoButton.vue?vue&type=script&lang=js"
export * from "./InfoButton.vue?vue&type=script&lang=js"

import "./InfoButton.vue?vue&type=style&index=0&id=1f0dde31&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0dde31"]])

export default __exports__